export default __webpack_public_path__ + "static/media/icon-steto.1965da09.svg";